import { render, staticRenderFns } from "./CaptureEmail.vue?vue&type=template&id=01e9b75e"
import script from "./CaptureEmail.vue?vue&type=script&lang=js"
export * from "./CaptureEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports